import ExternalRedirect from './externalRedirect.component';

export default ExternalRedirect;
